import { useEffect, useState } from "react";

export const useAuth = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user") || "null"));

  const login = (newToken, userData) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("user", JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
  };

  // Mehrere Fenster (Hauptfenster + Kalender-Fenster): Anmelden/Abmelden in einem Fenster gilt sofort in allen
  useEffect(() => {
    const beiStorage = (e) => {
      if (e.key !== "token" && e.key !== "user" && e.key !== null) return;
      setToken(localStorage.getItem("token"));
      try { setUser(JSON.parse(localStorage.getItem("user") || "null")); } catch { setUser(null); }
    };
    window.addEventListener("storage", beiStorage);
    return () => window.removeEventListener("storage", beiStorage);
  }, []);

  return { token, user, login, logout, isAuthenticated: !!token };
};
